import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="flex items-center justify-center min-h-[60vh]" data-testid="payment-cancel-page">
        <Card className="max-w-md w-full p-8 border border-slate-200 text-center space-y-6">
          <div className="mx-auto w-20 h-20 rounded-full bg-slate-100 flex items-center justify-center">
            <XCircle size={44} className="text-slate-400" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900">Payment Cancelled</h2>
          <p className="text-slate-500">No worries! Your account has not been charged. You can try again anytime.</p>
          <div className="flex gap-3 pt-2">
            <Button variant="outline" onClick={() => navigate('/dashboard')} className="flex-1" data-testid="back-to-dashboard-btn">
              <ArrowLeft size={16} className="mr-2" />
              Dashboard
            </Button>
            <Button onClick={() => navigate('/credits')} className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="try-again-btn">
              <CreditCard size={16} className="mr-2" />
              Try Again
            </Button>
          </div>
        </Card>
      </div>
    </Layout>
  );
};

export default PaymentCancel;
